import React, { useEffect, useState } from "react";
import { Container } from "./style";
import Input from "../../../../components/FormElement/Search";
import TextArea from "../../../../components/FormElement/TextArea";
import Button from "../../../../components/FormElement/Button";
import ImageUpload from "../../../../components/FormElement/ImageUpload";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useHideModal } from "../../../../hooks";
import { Rate } from "antd";
import { useShowAlert } from "../../../../hooks/useAlerts";
import LangTab from "../../../../components/FormElement/LangTab";
import service from "../../../../services/feedback";
import Spinner from "../../../../components/Spinner/FullScreen";

const Form = ({ data, refreshData }) => {
  const [loading, setLoading] = useState(false);
  const { hideModal } = useHideModal();
  const { error } = useShowAlert();
  const [fileList, setFileList] = useState([]);
  const [language, setLanguage] = useState("UZL");

  const validationSchema = Yup.object({
    full_name: Yup.object().shape({
      UZL: Yup.string().required("Kiritish shart!"),
      UZK: Yup.string().required("Kiritish shart!"),
      RUS: Yup.string().required("Kiritish shart!"),
      ENG: Yup.string().required("Kiritish shart!"),
    }),
    desc: Yup.object().shape({
      UZL: Yup.string().required("Kiritish shart!"),
      UZK: Yup.string().required("Kiritish shart!"),
      RUS: Yup.string().required("Kiritish shart!"),
      ENG: Yup.string().required("Kiritish shart!"),
    }),
    position: Yup.object().shape({
      UZL: Yup.string().required("Kiritish shart!"),
      UZK: Yup.string().required("Kiritish shart!"),
      RUS: Yup.string().required("Kiritish shart!"),
      ENG: Yup.string().required("Kiritish shart!"),
    }),
    rate: Yup.string().required("Kiritish shart!"),
    fileList: Yup.array().min(1).required("Kiritish shart!"),
  });

  const formik = useFormik({
    initialValues: {
      full_name: {
        UZL: "",
        UZK: "",
        RUS: "",
        ENG: "",
      },
      desc: {
        UZL: "",
        UZK: "",
        RUS: "",
        ENG: "",
      },
      position: {
        UZL: "",
        UZK: "",
        RUS: "",
        ENG: "",
      },

      fileList: [],
      rate: 0,
    },
    validationSchema,
    // validateOnMount: true,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("full_name[UZL]", values.full_name.UZL);
      formData.append("full_name[RUS]", values.full_name.RUS);
      formData.append("full_name[UZK]", values.full_name.UZK);
      formData.append("full_name[ENG]", values.full_name.ENG);
      formData.append("desc[UZL]", values.desc.UZL);
      formData.append("desc[RUS]", values.desc.RUS);
      formData.append("desc[UZK]", values.desc.UZK);
      formData.append("desc[ENG]", values.desc.ENG);
      formData.append("position[UZL]", values.position.UZL);
      formData.append("position[RUS]", values.position.RUS);
      formData.append("position[UZK]", values.position.UZK);
      formData.append("position[ENG]", values.position.ENG);

      formData.append("rate", values.rate);
      fileList?.forEach((el) => {
        if (el.originFileObj) {
          formData.append(`file`, el.originFileObj);
        }
      });
      setLoading(true);
      if (data) {
        service
          .update(data, formData)
          .then(() => {
            hideModal();
            refreshData();
          })
          .catch((err) => {
            console.log(err);
            error(
              "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
            );
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        service
          .create(formData)
          .then(() => {
            hideModal();
            refreshData();
          })
          .catch((err) => {
            console.log(err);
            error(
              "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
            );
          })
          .finally(() => {
            setLoading(false);
          });
      }
    },
  });

  useEffect(() => {
    if (data) {
      setLoading(true);
      service
        .getOne(data)
        .then((resp) => {
          formik.setValues({
            full_name: {
              UZL: resp?.full_name?.UZL,
              UZK: resp?.full_name?.UZK,
              RUS: resp?.full_name?.RUS,
              ENG: resp?.full_name?.ENG,
            },
            desc: {
              UZL: resp?.desc?.UZL,
              UZK: resp?.desc?.UZK,
              RUS: resp?.desc?.RUS,
              ENG: resp?.desc?.ENG,
            },
            position: {
              UZL: resp?.position?.UZL,
              UZK: resp?.position?.UZK,
              RUS: resp?.position?.RUS,
              ENG: resp?.position?.ENG,
            },
            rate: resp?.rate,
          });
          resp?.photo && setFileList([resp?.photo]);
        })
        .catch((err) => {
          console.log(err);
          error(
            "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [data]);

  const onLangChange = (key) => {
    setLanguage(key);
  };

  useEffect(() => {
    formik.setFieldValue("fileList", fileList);
  }, [fileList]);

  if (loading) return <Spinner />;
  return (
    <Container>
      <form onSubmit={formik.handleSubmit}>
        <div className="rate-wrapper">
          <Rate
            onChange={(value) => formik.setFieldValue("rate", value)}
            initialValues={3}
            value={formik.values.rate}
          />
        </div>
        <LangTab defaultActiveKey="1" onChange={onLangChange} />
        <Input
          id="full_name"
          name="full_name"
          label="Ism-familiya"
          width={100}
          placeholder="Abduvahobov Inomjon"
          onChange={(e) => {
            formik.setFieldValue(`full_name.${language}`, e.target.value);
          }}
          value={formik.values?.full_name[language]}
          status={
            formik?.errors?.full_name && formik.touched.full_name ? "error" : ""
          }
        />
        <Input
          id="position"
          name="position"
          label="Lavozim"
          width={100}
          placeholder="UX/UI dizayner"
          onChange={(e) => {
            formik.setFieldValue(`position.${language}`, e.target.value);
          }}
          value={formik.values?.position[language]}
          status={
            formik?.errors?.position && formik.touched.position ? "error" : ""
          }
        />
        <TextArea
          id="desc"
          name="desc"
          label="Izoh"
          width={100}
          placeholder="Izoh"
          onChange={(e) => {
            formik.setFieldValue(`desc.${language}`, e.target.value);
          }}
          value={formik.values?.desc[language]}
          status={formik?.errors?.desc && formik.touched.desc ? "error" : ""}
        />

        <div className="upload-wrapper">
          <ImageUpload
            maxCount={1}
            multiple={true}
            fileList={fileList}
            setFileList={setFileList}
            status={
              formik?.errors?.fileList && formik.touched.fileList ? true : false
            }
          />
        </div>

        <Button
          text={data ? "Tahrirlash" : "Saqlash"}
          htmlType="submit"
          width="100%"
        />
      </form>
    </Container>
  );
};

export default Form;
